<div class="col-12">
  <h4>{{ "accounts.transaction_history.transaction_history" | translate }}</h4>
  <div class="card border border-primary p-2 mx-auto" style="max-width: 400px; border-width: 2px !important; border-radius: .6rem;">
    <div class="row d-flex justify-content-between align-items-center">
      <div class="col-auto text-secondary small">{{ "accounts.transaction_history.available_balance" | translate }}:</div>
      <div class="col-auto fw-bold">
        {{ ((balance && balance <= 0) ? 0 : balance) | currency:'$':'symbol':'1.2':'en' }}
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-auto text-center">
      <p *ngIf="today" class="mb-2">
        <b>{{ "accounts.transaction_history.period" | translate }}:</b>
        {{ lastMonthSameDay.locale(translate.currentLang).format('MMM DD YYYY') }}
        <i class="fas fa-arrow-right" style="font-size: 0.75em;"></i>
        {{ today.locale(translate.currentLang).format('MMM DD YYYY') }}
      </p>
      <div class="mx-auto" style="max-width: 400px; width: 100%;">
        <button class="btn btn-primary w-100 mb-2" (click)="this.router.navigate(['/account/accountStatement'])">
          <i class="fas fa-history"></i> {{ "accounts.transaction_history.monthly_statements" | translate }}
        </button>
      </div>
    </div>
  </div>

  <p-table [value]="movements" dataKey="reference" [scrollable]="true" responsiveLayout="stack" scrollHeight="400px" styleClass="p-datatable-striped">
    <!--ng-template pTemplate="header">
      <tr>
        <th class="headerArrowTable"></th>
        <th>{{ "accounts.transaction_history.description" | translate }}</th>
        <th>{{ "accounts.transaction_history.amount" | translate }}</th>
      </tr>
    </-ng-template-->
    <ng-template pTemplate="body" let-mov>
      <tr (click)="this.setCurrentMovement(mov); displayMovement = true;"  [style.cursor]="'pointer'">
        <td style="width: 5rem">
          <i *ngIf="mov.movementType == eMovementType.CHARGE" class="fas fa-arrow-circle-up text-danger"></i>
          <i *ngIf="mov.movementType == eMovementType.CREDIT" class="fas fa-arrow-circle-down text-success"></i>
        </td>
        <td><span class="p-column-title">{{ "accounts.transaction_history.description" | translate }}</span>
          <h5 class="mb-0">{{ mov.merchantName }}</h5>
          <div class="text-muted small">{{ mov.description }}</div>
          <div class="text-muted small">{{ this.getFormattedDate(mov.date) }}</div>
        </td>
        <td [ngClass]="{'positive-amount': mov.movementType == eMovementType.CREDIT, 'negative-amount': mov.movementType == eMovementType.CHARGE}">
          <span class="p-column-title">{{ "accounts.transaction_history.amount" | translate }}</span>
          {{ mov.amount | currency: 'US $':'symbol':'1.2':'en' }}
          <div class="text-muted small">{{ "accounts.transaction_history.detail" | translate }}</div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">
          <div class="alert alert-info text-center" role="alert">
            <i class="fas fa-info-circle fa-2x"></i>
            <p class="m-0" *ngIf="selectedValue?.name == this.pastMonthName || selectedValue?.name == this.twoMonthsAgoName">{{ "accounts.transaction_history.no_movements_month" | translate }}</p>
            <p class="m-0" *ngIf="selectedValue?.name != this.pastMonthName && selectedValue?.name != this.twoMonthsAgoName">{{ "accounts.transaction_history.no_movements" | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>


<!-- region Movement -->
<p-dialog header=" " [(visible)]="displayMovement" [modal]="true" [baseZIndex]="10000" [style]="{ width: '50vw', maxWidth: '800px'}" [contentStyle]="{ 'padding-bottom': '0' }"  [styleClass]="'no-header-padding'">
  <!-- Encabezado con ícono, monto y subtítulo -->
  <div class="d-flex align-items-center justify-content-center mb-3 w-100">
    <!-- Ícono circular -->
    <div class="d-flex align-items-center justify-content-center mr-2">
      <i *ngIf="this.currentMovement?.movementType == eMovementType.CHARGE" class="fas fa-arrow-circle-up text-danger fa-2x"></i>
      <i *ngIf="this.currentMovement?.movementType == eMovementType.CREDIT" class="fas fa-arrow-circle-down text-success fa-2x"></i>
    </div>

    <!-- Texto de monto y tipo de transacción -->
    <div>
      <h4>{{ this.currentMovement?.amount | currency:'$':'symbol':'1.2':'en' }}</h4>
      <div *ngIf="this.currentMovement?.movementType == eMovementType.CHARGE" class="text-muted text-uppercase small">{{ "accounts.transaction_history.purchase" | translate }}</div>
      <div *ngIf="this.currentMovement?.movementType == eMovementType.CREDIT" class="text-muted text-uppercase small">{{ "accounts.transaction_history.deposit" | translate }}</div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-center flex-column">
    <p *ngIf="this.currentMovement?.description" class="m-0 small d-flex justify-content-between w-100 ">
      <span class="text-start">{{ "accounts.transaction_history.description" | translate }}</span>
      <span class="text-end">{{ this.currentMovement?.description.trim() }}</span>
    </p>
    <p *ngIf="this.currentMovement?.reference" class="m-0 small d-flex justify-content-between w-100 ">
      <span class="text-start">{{ "accounts.transaction_history.numerical_reference" | translate }}</span>
      <span class="text-end">{{ this.currentMovement?.reference.trim() }}</span>
    </p>
    <p *ngIf="this.currentMovement?.merchantName" class="m-0 small d-flex justify-content-between w-100 ">
      <span class="text-start">{{ "accounts.transaction_history.merchant" | translate }}</span>
      <span class="text-end">{{ this.currentMovement?.merchantName.trim() }}</span>
    </p>
    <p *ngIf="this.currentMovement?.merchantCity" class="m-0 small d-flex justify-content-between w-100 ">
      <span class="text-start">{{ "accounts.transaction_history.location" | translate }}</span>
      <span class="text-end">{{ this.currentMovement?.merchantCity.trim() }}</span>
    </p>
    <p *ngIf="this.currentMovement?.terminalId" class="m-0 small d-flex justify-content-between w-100 ">
      <span class="text-start">{{ "accounts.transaction_history.terminal_id" | translate }}</span>
      <span class="text-end">{{ this.currentMovement?.terminalId.trim() }}</span>
    </p>
    <p *ngIf="this.currentMovement?.date" class="m-0 small d-flex justify-content-between w-100 ">
      <span class="text-start">{{ "accounts.transaction_history.terminal_id" | translate }}</span>
      <span class="text-end">{{ getFormattedDate(this.currentMovement?.date) }}</span>
    </p>
  </div>
  <hr>
  <div class="d-flex align-items-center justify-content-center w-100" (click)="displayMovement = false" [style.cursor]="'pointer'">
    <p class="text-success" >{{ "accounts.target_account.ok" | translate}}</p>
  </div>
</p-dialog>
<!-- endregion Movement -->